const ResearchTrainingTable = () => {
    return (
        <>
            <div className="filter-container mt-0">
                <table className="views-table full-width">
                    <thead>
                        <tr>
                            <th className="f-project-title" style={{width: "180px" }} >Course Title </th>
                            <th className="f-project-lead" style={{width: "180px" }} >Relevance </th>
                            <th className="f-project-entity" style={{width: "180px" }} >Recommended Applications within HBKU </th>
                            <th className="f-project-entity" style={{width: "60px" }} >Duration (hrs) </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="odd">
                            <td>Choosing the Best Journal for Your Paper</td>
                            <td>Enhances technical writing for high-impact publications</td>
                            <td>Link to thesis and publication workshops</td>
                            <td>4</td>
                        </tr>
                        <tr className="even">
                            <td>Publishing a Research Paper: 2nd Edition</td>
                            <td>Enhances technical writing for high-impact publications</td>
                            <td>Link to thesis and publication workshops</td>
                            <td>6</td>
                        </tr>
                        <tr className="odd">
                            <td>Persuasive Grant Writing	</td>
                            <td>Strengthens proposal competitiveness	</td>
                            <td>Align with grant application requirements </td>
                            <td>7.5</td>
                        </tr>
                        <tr className="even">
                            <td>Advancing your Scientific Presentations	</td>
                            <td>Improves presentation design and delivery	</td>
                            <td>Integrate into research communication training coordinated by HBKU Research Office; offer as pre-conference preparation	</td>
                            <td>10</td>
                        </tr>
                        <tr className="odd">
                            <td>Building a Strong Online Researcher Profile	</td>
                            <td>Builds researcher digital identity and outreach	</td>
                            <td>Align with researcher profile development initiatives; include in ORCID/Google Scholar/LinkedIn workshops</td>
                            <td>1</td>
                        </tr>
                        <tr className="even">
                            <td>Creating Successful Research Posters	</td>
                            <td>Prepares for conference participation	</td>
                            <td>Use in poster day preparation sessions and research showcase training for early-career researchers	</td>
                            <td>4.5</td>
                        </tr>
                        <tr className="odd">
                            <td>Data Analysis: Conducting and Troubleshooting	</td>
                            <td>Builds critical data skills	</td>
                            <td>Integrate into data literacy and analysis modules in experimental research training tracks	</td>
                            <td>5</td>
                        </tr>
                        <tr className="even">
                            <td>Data Analysis: Planning and Preparing	</td>
                            <td>Strengthens analytical problem-solving	</td>
                            <td>Include in applied research methodology and statistics training; link to lab induction programs	</td>
                            <td>5</td>
                        </tr>
                        <tr className="odd">
                            <td>Effective Science Communication	</td>
                            <td>Builds public engagement and policy outreach skills	</td>
                            <td>Offer as part of science-policy interface and public engagement initiatives,	</td>
                            <td>6.5</td>
                        </tr>
                        <tr className="even">
                            <td>Experiments: From Idea to Design	</td>
                            <td>Strengthens research design skills	</td>
                            <td>Include in research design curriculum; link to supervised lab rotation programs	</td>
                            <td>8.5</td>
                        </tr>
                        <tr className="odd">
                            <td>Finding Funding Opportunities	</td>
                            <td>Equips researchers with funding landscape awareness	</td>
                            <td>Integrate into funding strategy workshops organized by HBKU Research Office; part of PI development programs	</td>
                            <td>3.5</td>
                        </tr>
                        <tr className="even">
                            <td>Focus on Peer Review	</td>
                            <td>Improves critical assessment of research	</td>
                            <td>Embed into peer review mentoring schemes	</td>
                            <td>3.5</td>
                        </tr>
                        <tr className="odd">
                            <td>Getting an Academic Research Position	</td>
                            <td>Provides career development guidance	</td>
                            <td>Include in academic career development workshops	</td>
                            <td>9.5</td>
                        </tr>
                        <tr className="even">
                            <td>Interpreting Scientific Results	</td>
                            <td>Develops analytical reasoning and critical thinking	</td>
                            <td>Integrate into advanced research skills training for experimental and theoretical programs	</td>
                            <td>3.5</td>
                        </tr>
                        <tr className="odd">
                            <td>Introduction to Collaboration	</td>
                            <td>Prepares researchers for team-based projects	</td>
                            <td>Offer as part of cross-RI collaboration skills training; link to interdisciplinary project initiation	</td>
                            <td>2.5</td>
                        </tr>
                        <tr className="even">
                            <td>Leading a Collaboration	</td>
                            <td>Builds leadership and project management capabilities	</td>
                            <td>Include in leadership and project management development modules	</td>
                            <td>11.5</td>
                        </tr>
                        <tr className="odd">
                            <td>Managing Research Data	</td>
                            <td>Strengthens data stewardship	</td>
                            <td>Embed in research data training for all RIs	</td>
                            <td>10</td>
                        </tr>
                        <tr className="even">
                            <td>Maximizing the Impact of Your Paper	</td>
                            <td>Boosts research visibility and citations	</td>
                            <td>Offer as part of research impact enhancement sessions; integrate with open access publishing support	</td>
                            <td>1.5</td>
                        </tr>
                        <tr className="odd">
                            <td>Narrative Tools for Researchers	</td>
                            <td>Enhances storytelling for grant proposals and interdisciplinary collaboration	</td>
                            <td>Incorporate into proposal and grant-writing ; link to interdisciplinary collaboration grants	</td>
                            <td>8.5</td>
                        </tr>
                        <tr className="even">
                            <td>Networking for Researchers	</td>
                            <td>Builds professional visibility	</td>
                            <td>Align with HBKU academic event series; integrate into networking sessions at conferences	</td>
                            <td>8</td>
                        </tr>
                        <tr className="odd">
                            <td>Participating in a Collaboration</td>
                            <td>Improves coordination and contribution to joint work</td>
                            <td>Offer during interdisciplinary project onboarding; align with consortium-building activities</td>
                            <td>5</td>
                        </tr>
                        <tr className="even">
                            <td>Research Integrity: Publication Ethics	</td>
                            <td>Promotes ethical research practices	</td>
                            <td>Mandate in Responsible Conduct of Research training modules across HBKU	</td>
                            <td>8</td>
                        </tr>
                        <tr className="odd">
                            <td>Writing a Research Paper: 2nd Edition	</td>
                            <td>Enhances technical writing for high-impact publications	</td>
                            <td>Include in literature review and thesis writing workshops at graduate level	</td>
                            <td>14.5</td>
                        </tr>
                        <tr className="even">
                            <td>Writing and Publishing a Review Paper: 2nd Edition	</td>
                            <td>Broadens academic contribution	</td>
                            <td>Embed in advanced publication skills training; link to systematic review methodology workshops	</td>
                            <td>4</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default ResearchTrainingTable;